import styled from 'styled-components'

import { Box } from '@material-ui/core'

const FullScreenSection = styled(Box)`
  height: 100vh;
`

export default FullScreenSection
